import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { wizard, meta, modal } from 'helpers/decorators'
import { Contact } from 'components/forms'
import { Button, FormDebug, Title, Note, AssessorFileCard } from 'components/misc'
import { Checkbox, Input, InputDate, InputPhone, Select } from 'components/fields'
import { apiCodeLists, apiAssessors } from 'helpers/decorators/api'
import { validate } from './contact-details.validation'
import styles from '../Experience/experience.styl'
import MODALS from '../../../../constants/layout/modals'
import { FileLoader } from '../../../../components/loaders'
import { ElevatedButton } from '../../../../components/layout'
import { Field } from 'redux-form'
import FieldError from '../../../../components/misc/FieldError/FieldError'
import queryString from 'query-string'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { AssessorFileDeleteModal, AssessorFileUploadModal } from '../../../../components/modals'

const asyncValidate = (val, dispatch, props) => {
  const { values } = props
  const error = {
    text: 'E-mail address is already in use.',
    intlKey: 'errors.email_address_is_in_use'
  }

  const errorSameEmails = {
    text: 'E-mail cannot be the same.',
    intlKey: 'errors.emails_cannot_be_same'
  }

  if (!get(values, 'secondaryEmail') && !get(values, 'tertiaryEmail')) {
     return new Promise(resolve => resolve())
  }

  const promises = []

  const secondaryEmail = get(values, 'secondaryEmail')

  const tertiaryEmail = get(values, 'tertiaryEmail')

  if (secondaryEmail) {
    promises.push(props.checkEmail({ email: secondaryEmail }))
  } else {
    promises.push(Promise.resolve())
  }

  if (tertiaryEmail) {
    promises.push(props.checkEmail({ email: tertiaryEmail }))
  } else {
    promises.push(Promise.resolve())
  }

  return Promise.all(promises).then(([secondaryEmailResult, tertiaryEmailResult]) => {
    if (secondaryEmail === tertiaryEmail) {
        // eslint-disable-next-line
        throw { tertiaryEmail: errorSameEmails }
    }

    if (get(tertiaryEmailResult, 'body.value') === true) {
      // eslint-disable-next-line
      throw { tertiaryEmail: error }
    }

    if (get(secondaryEmailResult, 'body.value') === true) {
      // eslint-disable-next-line
      throw { secondaryEmail: error }
    }
  })
}

@modal.trigger()
@apiCodeLists(['phoneTypes'], {
  public: true
})
@apiAssessors()
@wizard({
  form: 'assessorRegistration',
  multipage: true,
  validate,
  destroyOnUnmount: false,
  asyncValidate,
  // asyncBlurFields: ['email']
})
@meta({
  title: 'Contact details',
  intlKey: 'moduleTitle.contact_details'
})
@connect(state => ({
  fileUploading: state.api.blob.loading,
  wwcFile: get(state.api.assessor.registration.files, 'wwc', {}),
  filesLoading: get(state.api.assessor.registration.files, 'loading'),
  submitFailed: get(state.form, 'assessorRegistration.submitFailed'),
}), { push })
class ContactDetails extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    values: PropTypes.object,
    assessor: PropTypes.object,
    fileUploading: PropTypes.bool,
    filesLoading: PropTypes.bool,
    wwcFile: PropTypes.object,
    onUploadAssessorWWCFile: PropTypes.func,
    onLoadAssessorWWCFile: PropTypes.func,
    onDeleteAssessorWWCFile: PropTypes.func,
    submitFailed: PropTypes.bool,
    change: PropTypes.func,
    modalObj: PropTypes.object,
  }

  async componentDidMount() {
    const query = queryString.parse(get(this.props, 'location.search'))

    const authCode = get(query, 'authorizationCode')

    await this.props.onLoadAssessorWWCFile(authCode)
    this.props.change('isExempted', false)
    this.props.change('isApplyCPNNeeded', false)
  }

  componentWillReceiveProps (nextProps) {
    if (get(this.props, 'wwcFile.id') !== get(nextProps, 'wwcFile.id')) {
      this.props.change('helpers.wwcFile', get(nextProps, 'wwcFile.id'))
    }
  }


  render() {
    const {
      assessor,
      handleSubmit,
      onSubmit,
      values,
      codeLists,
      filesLoading,
      wwcFile,
      errors,
      submitFailed,
      fileUploading,
      modalObj
      } = this.props

    const continuationRegistration = get(
      assessor,
      'profile.data.continuationRegistration',
      false
    )

    const query = queryString.parse(get(this.props, 'location.search'))

    const authCode = get(query, 'authorizationCode')

    const wwcFileId = get(wwcFile, 'id')

    const wwcFileError = get(errors, 'wwcFile')

    const assessorRegistrationId = get(assessor, 'profile.data.id')

    const isExempted = get(values, 'isExempted')

    const isApplyCPNNeeded = get(values, 'isApplyCPNNeeded')

    const showWWCDetails = !(isExempted || isApplyCPNNeeded)

    const showIsApplyCPNNeeded = !isExempted

    const showIsExempted = !isApplyCPNNeeded

    return (
      <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Title intlKey="moduleTitle.contact_details" h2>
          Contact Details
        </Title>
        <Note hideNodePrefix={true} margin="10px 0 20px 0">
          <FormattedMessage
            id="label.assessor_contact_details_desc"
            defaultMessage="Please note that this information will be visible to Award Leaders for the purposes of contacting you if necessary."
          />
        </Note>
        <Contact
          isEmalFixed={continuationRegistration}
          isEmailDisabled
          phoneTypes={codeLists.phoneTypes.list}
          confirmEmailAddress={false}
          showOtherEmails={true}
          selectedCountryIcoCode="au"
        />
        <Title intlKey="moduleTitle.company_details" h2>
          Company Details
        </Title>
        <Note intlKey="label.no_company_leave_empty" lighter>
          If you don't work for any company, leave empty
        </Note>
        <div className="row">
          <div className="col-xs-12 col-md-4">
            <Input
              name="company"
              label="Company name"
              intlKey="label.company_name"
            />
          </div>
          <div className="col-xs-12 col-md-4">
            <InputPhone
              name="companyNumber"
              label="Phone number"
              intlKey="label.phone_number"
              selectedCountryIcoCode="au"
            />
          </div>
        </div>

        <Title intlKey="moduleTitle.wwc_details" h2>
          Work with Children Details
        </Title>
        <Note hideNodePrefix={true} margin="15px 0 15px 0">
          <FormattedMessage
            id="label.wwc_details_desc"
            defaultMessage="Editable text in POEditor."
          />
        </Note>
        <div className="row">
        <div className="col-md-4">
          {showIsApplyCPNNeeded && <Checkbox
            name="isApplyCPNNeeded"
            label="I need to apply for my CPN"
            intlKey="label.i_need_to_apply_cpn"
          />}
        </div>

          {showIsExempted && <div className="col-md-4">
            <Checkbox
              name="isExempted"
              label="Exempted"
              intlKey="label.exempted"
            />
          </div>}

          {isExempted && <div className="col-md-4">
            <Input
              label="Reason"
              intlKey="label.reason"
              name="exemptionReason"
            />
          </div>}
        </div>
        <div className="row">

          {showWWCDetails && <div className="col-xs-12 col-md-4">
            <Input
              name="childProtectionNumber"
              label="WWC application number"
              intlKey="label.wwc_application_number"
            />
          </div>}
          {showWWCDetails && <div className="col-xs-12 col-md-4">
            <InputDate
              name="childProtectionExpirationDate"
              label="WWC expiration date"
              intlKey="label.wwc_expiration_date"
              minToday
              yearsInAdvance={10}
            />
          </div>}
        </div>

        {showWWCDetails && <div className={styles.uploadFile}>
          <p className="note">
            <FormattedMessage
              id="label.assessor_registration_wwc_upload_file"
              defaultMessage="You can upload your WWC file here."
            />
          </p>
          {!filesLoading.loading ? (
            <div className="row">
              <div key={wwcFileId} className="col-xs-12 col-sm-6">
                {get(wwcFile, 'id') && <AssessorFileCard
                  src={get(wwcFile, 'fileUrl')}
                  file={wwcFile}
                  fileId={wwcFileId}
                  onDeleteClick={() =>
                    this.props.onOpen(MODALS.ASSESSOR_FILE_DELETE, null, {
                      wwcFileId,
                      authCode
                    })
                  }
                />}
              </div>
            </div>
          ) : (
            <FileLoader />
          )}

          {!get(wwcFile, 'id') && <ElevatedButton
            onClick={() => this.props.onOpen(MODALS.ASSESSOR_FILE_UPLOAD)}
            intlKey="button.upload_file"
            rounded
            uppercase
          >
            Upload file
          </ElevatedButton>}
          <Field name="wwcFile" component="input" type="hidden" /> {/* prevent submit */}
          <FieldError toShow={submitFailed} message={wwcFileError} />
        </div>}

        <FormDebug values={values} />
        <div>
          <Button type="submit">
            <FormattedMessage id="button.continue" defaultMessage="Continue" />
          </Button>
        </div>
      </form>

    <AssessorFileUploadModal
      modalId={MODALS.ASSESSOR_FILE_UPLOAD}
      onSubmit={this.props.onUploadAssessorWWCFile}
      authCode={authCode}
      loading={fileUploading}
      assessorRegistrationId={assessorRegistrationId}
    />
    <AssessorFileDeleteModal
      modalId={MODALS.ASSESSOR_FILE_DELETE}
      onClose={this.props.onClose}
      onConfirm={() => this.props.onDeleteAssessorWWCFile(modalObj.data)}
    />
    </div>
    )
  }
}

export default ContactDetails
